import searchRouteUrl from './newsfeed-search-route.html';

class NewsfeedSearchCtrl {
  constructor(NewsfeedCollection, NewsfeedReactBridge, $state, $scope) {
    'ngInject';

    Object.assign(this, { NewsfeedCollection, NewsfeedReactBridge, $state, $scope });
  }

  $onInit() {
    this.setPage();

    this.$scope.$on('$locationChangeSuccess', () => {
      const query = new URLSearchParams(window.location.search);
      this.searchPageId = Number(query.get('searchPageId')) ?? this.pageId;
      this.articleId = Number(query.get('articleId')) ?? null;
      this.query = query.get('query');

      this.setPage();
    });
  }

  setPage() {
    const page = this.getPageById(this.pageId) ?? this.getPageById(0);

    this.page = {
      id: Number(page.id),
      name: page.name,
    };
  }

  getPageById(pageId) {
    return this.NewsfeedCollection.allChannels.find((c) => String(c.id) === String(pageId));
  }

  navigate = (path, params, options) => {
    this.$state.go(path, params, options);
  };
}

export default {
  templateUrl: searchRouteUrl,
  controller: NewsfeedSearchCtrl,
  controllerAs: 'ctrl',
  bindings: {
    articleId: '<',
    pageId: '<',
    searchPageId: '<',
    query: '<',
  },
};
